import { render, staticRenderFns } from "./EtaIndex.vue?vue&type=template&id=cba782b2&scoped=true&"
import script from "./EtaIndex.vue?vue&type=script&lang=js&"
export * from "./EtaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba782b2",
  null
  
)

export default component.exports